<template>
    <div class="service-detail">
        <div class="bread-crumbs">
            <div class="crumbs-item" @click="onOrderListClick">订单列表</div>
            <Icon type="ios-arrow-forward" class="crumbs-icon" size="14" />
            <div class="crumbs-item" @click="onOrderDetail()">订单详情</div>
            <Icon type="ios-arrow-forward" class="crumbs-icon" size="14" />
            <div class="crumbs-item active">{{ order.type == 1 ? '退货退款':order.type == 2 ? '换货' :'退款' }}</div>
        </div>
        <div class="detail-body">
            <div class="order-step-box">
                <div class="order-step-info">
                    <div class="order-step-item" v-for="(item,index) in steps" :key="index">
                        <div :class="['line',{'active':item.line_active}]" v-if="index != 0"></div>
                        <div class="dot-info-box">
                            <div :class="['dot',{'active':item.dot_active}]"></div>
                            <div class="title">{{ item.title }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="order-status-box">
                <div class="status-text">
                    <div class="label">当前售后状态:</div>
                    <div class="value">
                        {{detail.status_text | status_filter(order.type)}}
                        <div class="tips" v-if="['create','wait_shop_confirm','wait_shop_send'].includes(detail.status_text)">
                            <div class="icon-blue">i</div>
                            <div class="text">您必须在{{ remaining_seconds | time_format }}内处理,超时将执行自动退款。</div>
                        </div>
                    </div>
                </div>
                <div class="btn-box">
                    <template v-if="detail.status_text == 'create'">
                        <div class="btn accept" @click="onApplyOrder(order)">同意{{ order.type|type_filter }}申请</div>
                        <div class="btn primary" @click="onRejectOrder(order)">拒绝{{ order.type|type_filter }}申请</div>
                    </template>
                    <div v-if="[1,2].includes(Number(order.type)) && detail.status_text == 'wait_shop_confirm'" class="btn primary" @click="onReciveOrder(order)">确认收货/拒绝收货</div>
                    <div v-if="detail.status_text == 'wait_shop_send'" class="btn primary" @click="onExchangeShipped(order)">填写发货信息</div>
                    <!-- <div v-if="[1,2].includes(Number(order.type))" class="btn info">拒绝收货(需填写原因)</div> -->
                </div>
            </div>
            <div class="info-body">
                <div class="left-body">
                    <template v-if="[1,3].includes(Number(detail.type))">
                        <div class="part-title">售后及商品信息</div>
                        <div class="product-info">
                            <img :src="goods.product_image|default_img" alt="" class="product-img" />
                            <div class="info-box">
                                <div class="product-name">{{goods.product_name}}</div>
                                <div class="product-spec">{{goods.spec_info}}</div>
                            </div>
                        </div>
                        <div class="time-order-no no-margin-bottom">
                            <p>申请时间:{{order.create_time}}</p>
                            <p>售后编号:{{detail.refund_no || '-'}}</p>
                            <p>订单编号:{{order.ord.order_no}}</p>
                        </div>
                    </template>
                    <div :class="['price-box',{'no-margin-top':detail.type == 3}]" v-if="[1,3].includes(Number(order.type))">
                        退款金额: <span class="price">￥{{order.apply_money}}</span>
                    </div>
                    <template v-if="order.type == 1" >
                        <div class="price-list-box">
                            <div class="list-item">
                                <span>退货商品金额</span>
                                <span>¥{{(goods.price*goods.quantity)|price_format}}</span>
                            </div>
                            <div class="list-item">
                                <span>发货运费</span>
                                <span>¥0.00</span>
                            </div>
                        </div>
                    </template>
                    <template v-if="order.type == 2">
                        <div class="part-title no-margin">售后及商品信息</div>
                        <div class="time-order-no">
                            <p>申请时间:{{order.create_time}}</p>
                            <p>售后编号:{{detail.refund_no || '-'}}</p>
                            <p>订单编号:{{order.ord.order_no}}</p>
                        </div>
                        <div class="part-title no-margin">售后商品列表</div>
                        <table>
                            <thead>
                                <tr>
                                    <th>商品信息</th>
                                    <th>价格</th>
                                    <th>数量</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <div class="product-col">
                                            <img :src="goods.product_image" alt="" class="product-img" />
                                            <div class="product-info">
                                                <div class="product-name">{{goods.product_name}}</div>
                                                <div class="product-spec">{{goods.spec_info}}</div>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <p>¥{{ goods.price }}</p>
                                        <p>¥{{ goods.tag_price }}</p>
                                    </td>
                                    <td>
                                        x{{ goods.quantity }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div class="part-title no-margin">换新商品列表</div>
                        <table>
                            <thead>
                                <tr>
                                    <th>商品信息</th>
                                    <th>价格</th>
                                    <th>数量</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <div class="product-col">
                                            <img :src="goods.product_image" alt="" class="product-img" />
                                            <div class="product-info">
                                                <div class="product-name">{{goods.product_name}}</div>
                                                <div class="product-spec">{{newSpec.spec_info || '-'}}</div>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <p>¥{{ newSpec.price }}</p>
                                        <p>¥{{ goods.tag_price }}</p>
                                    </td>
                                    <td>
                                        x{{ goods.quantity }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </template>
                    <div :class="['part-title']">售后原因及说明</div>
                    <div class="reason-box">
                        <div class="reason-item">
                            <p>售后类型:<span class="service-type">{{order.type|type_filter}}</span></p>
                        </div>
                        <p>退货原因:{{order.user_reason}}</p>
                        <p>退货备注说明:{{order.user_memo}}</p>
                        <p>买家上传凭证:</p>
                        <!-- TODO: 凭证图片展示 -->
                        <div class="img-list" v-viewer>
                            <template v-for="(item,index) in order.user_proof">
                                <img v-if="util.test_image(item)" :src="item|default_img" alt="" class="img-item" :key="`index-${index}`"/>
                                <div v-else-if="util.is_video(item)" class="video-wrapper" :key="`video-${index}`" @click="previewVideo(item)">
                                    <video :src="item" class="img-item video"></video>
                                    <div class="video-overlay"></div>
                                    <div class="video-play-icon">
                                        <svg viewBox="0 0 24 24" fill="white" width="24" height="24">
                                            <path d="M8 5v14l11-7z"/>
                                        </svg>
                                    </div>
                                </div>
                            </template>
                            <!-- <img v-for="(item,index) in order.user_proof" :key="index" v-if="util.test_image(item)" v-viewer :src="item|default_img" alt="" class="img-item" /> -->
                        </div>
                    </div>
                    <div class="part-title">买家信息</div>
                    <div class="buyer-info">
                        <div class="buyer-info-item">
                            <div class="buyer-info-label">买家昵称:</div>
                            <div class="buyer-info-value">
                                {{order.member.nickname || order.member.realname || '-'}}
                                <div class="contact-box" @click="onChatClick(order.member)"  v-if="userInfo.id !=  order.member.id">
                                    <img src="@/assets/images/shop-manage/icon-shop-order-service.png" alt="" class="icon" />
                                    <div class="text">联系买家</div>
                                </div>
                            </div>
                        </div>
                        <div class="buyer-info-item">
                            <div class="buyer-info-label">收货信息:</div>
                            <div class="buyer-info-value">{{`${order.ord.contact_person} ${order.ord.contact_mobile} ${order.ord.province}${order.ord.city}${order.ord.zone}${order.ord.address}`}}</div>
                        </div>
                    </div>
                </div>
                <div class="right-body">
                    <div class="right-part-title">
                        {{ detail.shop_send_time ? '寄出物流详情' : '退货详情' }}
                    </div>
                    <div class="return-info">
                        <p>{{detail.shop_send_time ? '下单' : '退货'}}时间:{{detail.shop_send_time ? detail.shop_send_time :detail.user_send_time}}</p>
                        <p>{{detail.shop_send_time ? '收货' : '退货'}}地址:{{address}}</p>
                        <p>物流公司:{{detail.shop_send_time ? detail.shop_logistics_name : detail.user_logistics_name}}</p>
                        <p>物流单号:{{detail.shop_send_time ? detail.shop_logistics_no : detail.user_logistics_no}}</p>
                        <p v-if="false">物流跟踪:</p>
                    </div>
                    <div class="logistics-info-right" v-if="trackingPanel.visible">
                        <div v-if="trackingPanel.loading" class="tracking-loading">物流轨迹加载中...</div>
                        <div v-else-if="!trackingPanel.list.length" class="empty-tracking">
                            暂无物流轨迹
                            <a style="margin-left:4px;cursor:pointer;color:#0d99ff" @click="viewLogistics(trackingPanel.name, trackingPanel.no)">重试</a>
                        </div>
                        <div v-else class="logistics-router-box">
                            <div class="logistics-router-item" v-for="(item,index) in trackingPanel.list" :key="index">
                                <div class="router-item-left" :class="{active:index==0}">{{ formatTime(item.opTime) }}</div>
                                <div :class="['router-item-center',{active:index==0}]"></div>
                                <div class="router-item-right">
                                    <div class="status" v-if="item.opDesc || item.addressText">{{ item.opDesc || item.addressText }}</div>
                                    <div class="status-desc" :class="{active:index==0}">{{ item.opMessage }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <template v-if="detail.shop_send_time">
                        <div class="right-part-title top-line">
                            退货详情
                        </div>
                        <div class="return-info">
                            <p>退货时间:{{detail.user_send_time}}</p>
                            <p>退货地址:{{`${shopInfo.return_name} ${shopInfo.return_mobile} ${shopInfo.return_address}`}}</p>
                            <p>物流公司:{{detail.user_logistics_name}}</p>
                            <p>物流单号:{{detail.user_logistics_no}}</p>
                            <p>物流详情:已签收</p>
                        </div>
                    </template>
                    <div class="remark-title">退货备注:</div>
                    <div class="remark">{{detail.shop_memo}}</div>
                </div>
            </div>
        </div>
        <div class="history-detail">
            <div class="history-title">进度详情</div>
            <div class="history-list">
                <div v-if="[1,2].includes(Number(detail.type)) && detail.complete_time" class="history-list-item">
                    <div class="history-list-item-title">卖家同意退款申请</div>
                    <p>商家同意退款申请,交易款项¥{{detail.apply_money}}元已原路返回响应账户。</p>
                    <p>{{detail.complete_time}}</p>
                </div>
                <div v-if="detail.shop_send_time" class="history-list-item">
                    <div class="history-list-item-title">商家换新</div>
                    <p>卖家已确认收货,并寄回换新商品</p>
                    <p>物流公司:{{detail.shop_logistics_name}}</p>
                     <p>物流单号:{{detail.shop_logistics_no}}</p>
                    <p>{{detail.shop_send_time}}</p>
                </div>
                <div v-if="detail.shop_receive_time" class="history-list-item">
                    <div class="history-list-item-title">卖家确认收货</div>
                    <p>{{detail.shop_receive_time}}</p>
                </div>
                <div v-if="detail.user_send_time" class="history-list-item">
                    <div class="history-list-item-title">买家退货</div>
                    <p>买家已寄出商品,等待卖家确认</p>
                    <p>物流公司:{{detail.user_logistics_name}}</p>
                    <p>物流单号:{{detail.user_logistics_no}}</p>
                    <p>{{detail.user_send_time}}</p>
                </div>
                <div v-if="detail.shop_handle_time" class="history-list-item">
                    <div class="history-list-item-title">{{detail.status_name}}</div>
                    <p>卖家已处理申请</p>
                    <p>{{detail.shop_handle_time}}</p>
                </div>
                <div class="history-list-item">
                    <div class="history-list-item-title">买家提交申请</div>
                    <p>买家申请退款退货,等待卖家确认</p>
                    <p>申请原因:{{detail.user_reason}}</p>
                    <p v-if="false">货品情况:{{ [1,2].includes(Number(detail.type)) ? '已收到货' : '未收到货' }}</p>
                    <p>{{ detail.create_time }}</p>
                </div>
            </div>
        </div>
        <chat ref="chat"></chat>
    </div>
</template>
<script>
import { AfterSaleDetail, GetLogisticsTracking } from '@/api/index';
import util from '@/utils/util';
import dayjs from 'dayjs';
import { mapState } from 'vuex';
export default{
    name:"ServiceDetail",
    components:{
    },
    props:{
        order:{
            type:Object,
            default:()=>{}
        }
    },
    filters:{
        type_filter(val){
            switch(Number(val)){
                case 1:
                    return '退货退款';
                case 2:
                    return '换货';
                default:
                    return '退款';
            }
        },
        status_filter(val,type){
            console.log('val--->status',val);
            switch(val){
                case 'cancel':
                    return '已取消售后';
                case 'complete':
                    if([1,3].includes(Number(type))){
                        return '退款成功';
                    }
                    return '换货成功';
                case 'wait_user_confirm':
                    return '换货商品已寄出,等待买家确认';
                case 'wait_shop_send':
                    return '等待寄出换货商品';
                case 'wait_shop_confirm':
                    return '原商品已寄回,等待商家确认';
                case 'wait_user_send':
                    return '等待买家寄回商品';
                default:
                    if(type == 1){
                        return '买家发起退货退款申请';
                    }
                    if(type == 2){
                        return '买家发起换货申请';
                    }
                    if(type == 3){
                        return '买家发起仅退款申请';
                    }
            }
        }
    },
    computed:{
        address(){
            const {shopInfo,order,detail} = this;
            if(!order || !detail) return '';
            const {province,city,zone,address} = order.ord;
            if(detail.shop_send_time){
                return `${order.ord.contact_person} ${order.ord.contact_mobile} ${province} ${city} ${zone} ${address}`;
            }
            return `${shopInfo.return_name} ${shopInfo.return_mobile} ${shopInfo.return_address}`
        },
        // 右侧物流区块当前展示的单号(有换新寄出时展示商家寄出,否则展示买家退回)
        currentLogisticsNo(){
            const {detail} = this;
            if(!detail) return '';
            return detail.shop_send_time ? detail.shop_logistics_no : detail.user_logistics_no;
        },
        currentLogisticsName(){
            const {detail} = this;
            if(!detail) return '';
            return detail.shop_send_time ? detail.shop_logistics_name : detail.user_logistics_name;
        },
        currentSendTime(){
            const {detail} = this;
            if(!detail) return '';
            return detail.shop_send_time || detail.user_send_time || '';
        },
        ...mapState({
            shopInfo:state=>state.shopInfo,
            userInfo:state=>state.userInfo,
        }),
        count_down(){
            const {order} = this;
            const {create_time} = order;

            //>如果create_time没有值,则返回当前时间+7天,使用dayjs
            if(!create_time){
                return dayjs().add(7,'day').format('YYYY-MM-DD HH:mm:ss');
            }
            //>如果create_time有值,则返回create_time+7天
            return dayjs(create_time).add(7,'day').format('YYYY-MM-DD HH:mm:ss');
        },
        steps(){
            const { detail } = this;
            const {
                type,
                create_time,
                shop_handle_time,
                user_send_time,
                shop_receive_time,
                shop_send_time,
                complete_time,
            } = detail;

            let data = [];

            switch (Number(type)) {
                default:
                    data = [
                        {
                            title: '买家提交申请',
                            dot_active: !_.isNull(create_time),
                            line_active: !_.isNull(create_time)
                        },
                        {
                            title: '卖家处理退款申请',
                            dot_active: !_.isNull(shop_handle_time),
                            line_active: !_.isNull(shop_handle_time) || !_.isNull(create_time)
                        },
                        {
                            title: '退款完毕',
                            dot_active: !_.isNull(complete_time),
                            line_active: !_.isNull(complete_time) || !_.isNull(shop_handle_time)
                        }
                    ];
                    break;
                case 1: // 退货退款
                    data = [
                        {
                            title: '买家提交申请',
                            dot_active: !_.isNull(create_time),
                            line_active: !_.isNull(create_time)
                        },
                        {
                            title: '客服审核',
                            dot_active: !_.isNull(shop_handle_time),
                            line_active: !_.isNull(shop_handle_time) || !_.isNull(create_time)
                        },
                        {
                            title: '商家收货',
                            dot_active: !_.isNull(shop_receive_time),
                            line_active: !_.isNull(shop_receive_time) || !_.isNull(shop_handle_time)
                        },
                        {
                            title: '退款处理',
                            dot_active: !_.isNull(complete_time),
                            line_active: !_.isNull(complete_time) || !_.isNull(shop_receive_time)
                        },
                        {
                            title: '退款成功',
                            dot_active: !_.isNull(complete_time),
                            line_active: !_.isNull(complete_time)
                        }
                    ];
                    break;
                case 2: // 换货
                    data = [
                        {
                            title: '买家提交申请',
                            dot_active: !_.isNull(create_time),
                            line_active: !_.isNull(create_time)
                        },
                        {
                            title: '客服审核',
                            dot_active: !_.isNull(shop_handle_time),
                            line_active: !_.isNull(shop_handle_time) || !_.isNull(create_time)
                        },
                        {
                            title: '买家退货',
                            dot_active: !_.isNull(user_send_time),
                            line_active: !_.isNull(user_send_time) || !_.isNull(shop_handle_time)
                        },
                        {
                            title: '商家收货',
                            dot_active: !_.isNull(shop_receive_time),
                            line_active: !_.isNull(shop_receive_time) || !_.isNull(user_send_time)
                        },
                        {
                            title: '换货处理',
                            dot_active: !_.isNull(shop_send_time),
                            line_active: !_.isNull(shop_send_time) || !_.isNull(shop_receive_time)
                        },
                        {
                            title: '换货完成',
                            dot_active: !_.isNull(complete_time),
                            line_active: !_.isNull(complete_time) || !_.isNull(shop_send_time)
                        }
                    ];
                    break;
            }
            console.log('data',data);
            return data;
        },
        goods(){
            const {order} = this;
            const {goods} = order;
            console.log('goods--->',goods);
            if(!goods) return {};
            return goods;
        },
        newSpec(){
            const {detail} = this;
            console.log('news_spec-detail1',detail);
            if(!detail) return {};
            const {newspec} = detail;
            console.log('news_spec_detail2',newspec);
            if(!newspec) return {};
            return newspec;
        }
    },
    data(){
        return{
            util,
            detail:{
                newSpec: {
                    spec_info: '',
                    price: 0,
                    tag_price: 0,
                    quantity: 0
                },
            },  
            count_bot:null,
            remaining_seconds:0,
            // 内联物流轨迹面板(不用弹窗)
            trackingPanel:{
                visible:false,
                loading:false,
                name:'',
                no:'',
                list:[]
            }
        };
    },
    mounted(){
        console.log('order-print-detail',this.order);
        this.startCountdown();
        this.onGetServiceDetail();
        // 监听list-refresh事件，当发货成功后刷新数据
        this.$bus.$on('list-refresh', () => {
            this.onGetServiceDetail();
        });
    },
    beforeDestroy() {
        // 组件销毁前移除事件监听
        this.$bus.$off('list-refresh');
        // 清理可能残留的视频预览弹窗
        const mask = document.querySelector('.video-preview-mask');
        if(mask) {
            mask.remove();
        }
    },
    methods:{
        onChatClick(user){
            this.$refs["chat"].showChat(null, user);
        },
        onExchangeShipped(order){
            console.log('order-exchange-shipped',order);
            this.$emit('exchange-shipped',order);
        },
        onReciveOrder(order){ 
            console.log('order-recive',order);
            this.$emit('recive-order',order);
        },
        onRejectOrder(order){ 
            console.log('order-reject',order);
            if([1,3].includes(Number(order.type))){
                //>拒绝退货
                this.$emit('reject-order',order);
            }else{
                //>拒绝换货
                this.$emit('reject-exchange',order);
            }
        },
        onApplyOrder(order){
            console.log('order-apply',order);
            console.log('order-type',order.type);
            if([1,3].includes(Number(order.type))){
                //>退货
                this.$emit('apply-order',order);
            }else{
                //>换货
                this.$emit('apply-exchange',order);
            }
        },
        async onGetServiceDetail(){
            try{
                const {code,msg,data} = await AfterSaleDetail({uuid:this.order.uuid});
                if(code>0){
                    this.$layer.msg(msg);
                    return;
                }
                console.log('service-detail--->',data);
                this.detail = data;
                // 有物流单号则自动展开轨迹
                if(this.currentLogisticsNo){
                    this.viewLogistics(this.currentLogisticsName, this.currentLogisticsNo, this.currentSendTime);
                }
            }catch(e){
                console.log('err-service-detail',e);
                this.$layer.msg(e.msg);
            }
        },
        // 打开内联物流轨迹面板(直接在本页展示，不用弹窗)
        async viewLogistics(logistics_name, logistics_no, send_time = ''){
            if(!logistics_no){
                this.$layer.msg('暂无物流单号');
                return;
            }
            this.trackingPanel = {
                visible: true,
                loading: true,
                name: logistics_name || '',
                no: logistics_no || '',
                list: []
            };
            try{
                const params = {
                    logistics_name: this.trackingPanel.name,
                    logistics_no: this.trackingPanel.no,
                };
                const { code, msg, data } = await GetLogisticsTracking(params);
                if(code > 0){
                    this.$layer.msg(msg || '查询物流轨迹失败');
                    return;
                }
                let traceList = [];
                if(Array.isArray(data)){
                    traceList = data;
                } else if(data && Array.isArray(data.traceList)){
                    traceList = data.traceList;
                } else if(data && Array.isArray(data.traces)){
                    traceList = data.traces;
                }
                this.trackingPanel.list = traceList;
            }catch(e){
                console.error('查询物流轨迹失败', e);
                this.$layer.msg(e.msg || '查询物流轨迹失败');
            }finally{
                this.trackingPanel.loading = false;
            }
        },
        // 格式化物流时间(兼容时间戳/字符串)
        formatTime(time){
            if(!time) return '--';
            if(typeof time === 'string' && time.includes('-')) return time;
            const date = new Date(time);
            if(isNaN(date.getTime())) return time;
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },
         // 启动倒计时
         startCountdown() {
            const targetTime = this.count_down; // 获取目标时间
            this.updateRemainingSeconds(targetTime); // 初始化剩余秒数

            // 每秒更新一次
            this.count_bot = setInterval(() => {
                this.updateRemainingSeconds(targetTime);
            }, 1000);
        },

        // 更新剩余秒数
        updateRemainingSeconds(targetTime) {
            const now = dayjs();
            const target = dayjs(targetTime);
            const diff = target.diff(now, 'second'); // 获取秒级差值

            if (diff <= 0) {
                this.remaining_seconds = 0;
                this.clearCountdown(); // 清除定时器
                return;
            }

            this.remaining_seconds = diff; // 更新剩余秒数
        },

        // 清除定时器
        clearCountdown() {
            if (this.count_bot) {
                clearInterval(this.count_bot);
                this.count_bot = null;
            }
        },
        onOrderListClick(){
            this.$emit('order-list');
        },
        onOrderDetail(){
            // 不再传 order.ord（缺订单级 uuid/member），改由 index.vue 保留现有 curr_order 回跳订单详情
            this.$emit('detail');
        },
        async previewVideo(url){
            const mask = document.createElement('div');
            mask.className = 'video-preview-mask';
            mask.onclick = (e) => {
                if(e.target === mask) this.closeVideoPreview();
            };
            mask.innerHTML = `
                <div class="video-preview-container" onclick="event.stopPropagation()">
                    <div class="video-preview-close" onclick="event.stopPropagation(); this.closest('.video-preview-mask').__vueComponent.closeVideoPreview()">×</div>
                    <div class="video-preview-loading">
                        <div class="video-loading-spinner"></div>
                        <span class="video-detect-text">视频文件检测中...</span>
                    </div>
                </div>
            `;
            mask.__vueComponent = this;
            document.body.appendChild(mask);

            const playable = await util.probeVideoPlayable(url);
            if (!mask.parentNode) return;

            const container = mask.querySelector('.video-preview-container');
            if(playable){
                // 添加 video 元素到 container
                const video = document.createElement('video');
                video.src = url;
                video.controls = true;
                video.autoplay = true;
                video.className = 'video-preview';
                // 移除 loading，插入 video
                const loading = container.querySelector('.video-preview-loading');
                if(loading) loading.remove();
                container.appendChild(video);
            } else {
                const loading = container.querySelector('.video-preview-loading');
                if(loading){
                    loading.innerHTML = `
                        <div class="video-unplayable-box" onclick="event.stopPropagation(); this.closest('.video-preview-mask').__vueComponent.downloadVideo('${url}')">
                            <span class="hint-text">该视频只支持下载预览</span>
                            <span class="download-link">点击下载</span>
                        </div>
                    `;
                    loading.classList.remove('video-preview-loading');
                    loading.classList.add('video-unplayable-wrapper');
                }
            }
        },
        downloadVideo(url){
            util.downloadVideo(url);
        },
        closeVideoPreview(){
            const mask = document.querySelector('.video-preview-mask');
            if(mask) {
                mask.remove();
            }
        },
    }
}
</script>
<style lang="scss" scoped>
.service-detail{
    width:100%;
    display:flex;
    flex-direction:column;
    .bread-crumbs{
        display:flex;
        align-items:center;
        column-gap:8px;
        padding-bottom:22px;
        padding-top:20px;
        .crumbs-item{
            color:#999;
            font-size:14px;
            cursor:pointer;
            &:hover, &.active{
                color:#333;
            }
        }
    }
    .detail-body{
        width:100%;
        background:#fff;
        padding:0 30px;
        display:flex;
        flex-direction:column;
        margin-top:19px;
        .order-step-box {
            width:100%;
            display:flex;
            justify-content:center;
            align-items:center;
            margin-top:28px;
            border-bottom:1px solid #d6d6d6;
            .order-step-info{
                $order-red:#ff4d4f;
                $line-gray:#e5e5e5;
                $text-gray:#999;
                display:flex;
                align-items:flex-start;
                justify-content:space-between;
                padding:0 10px 20px 10px;
                .order-step-item{
                        display:flex;
                        flex-direction:column;
                        align-items:center;
                        justify-content:center;
                        position:relative;
                        width:151px;
                        .line{
                        width:calc(100% - 9px);
                        height:1px;
                        background:#e3e3e3;
                        position:absolute;
                        top:4px;
                        left:-47%;
                        &.active{
                            background:$order-red;
                        }
                        }
                        .dot-info-box{
                        display:flex;
                        flex-direction:column;
                        align-items:center;
                        justify-content:center;
                        .dot{
                            width:9px;
                            height:9px;
                            border:1px solid #e3e3e3;
                            border-radius:50%;
                            &.active{
                                background:$order-red;
                                border-color:$order-red;
                            }
                        }
                        .title{
                            color:#333;
                            font-size:14px;
                            margin-top:11px;
                        }
                        .time{
                            color:#999;
                            font-size:12px;
                            margin-top:3px;
                        }
                        }
                }
            }
        }
        .order-status-box{
            width:100%;
            display:flex;
            flex-direction:column;
            margin-top:29px;
            padding-bottom:32px;
            border-bottom:1px solid #d6d6d6;
            .status-text{
                display:flex;
                align-items:center;
                column-gap:8px;
                .label{
                    color:#333333;
                    font-size:13px;
                }
                .value{
                    color:#ff5000;
                    font-size:18px;
                    font-weight:bold;
                    display:flex;
                    align-items:center;
                    column-gap:13px;
                    .tips{
                        display:flex;
                        align-items:center;
                        justify-content:center;
                        column-gap:10px;
                        background:#f7faff;
                        padding:8px 18px;
                        .icon-blue{
                            width:20px;
                            height:20px;
                            border-radius:50%;
                            color:#fff;
                            line-height:20px;
                            text-align:center;
                            background:#0d99ff;
                        }
                        .text{
                            color:#666;
                            font-size:14px;
                        }
                    }
                }
            }
            .btn-box{
                display:flex;
                column-gap:16px;
                margin-top:33px;
                .btn{
                    width:fit-content;
                    height:32px;
                    line-height:32px;
                    border-radius:4px;
                    font-size:14px;
                    padding:0 12px;
                    cursor:pointer;
                    &.primary{
                        background:#ff5967;
                        color:#fff;
                        &.logistics{
                            padding:0 26px;
                        }
                    }
                    &.info{
                        background:#fff;
                        color:#666;
                        border:1px solid #b3b3b3;
                    }
                    &.accept{
                        background:#02c160;
                        color:#fff;
                    }
                }
            }
        }
        .info-body{
            width:100%;
            display:flex;
            justify-content:space-between;
            column-gap:165px;
            margin-top:26px;
            .left-body{
                flex:1;
                display:flex;
                flex-direction:column;
                .part-title{
                    color:#333;
                    font-size:16px;
                    margin-bottom:16px;
                    &.no-margin{
                        margin-bottom:0;
                    }
                }
                table{
                    width:719px;
                    border-collapse:collapse;
                    table-layout:fixed;
                    border:1px solid #ebedf2;
                    margin-top:18px;
                    margin-bottom:24px;
                    thead{
                        tr{
                            height:52px;
                            background:#f6f7fa;
                            th{
                                text-align:center;
                                color:#666;
                                font-size:14px;
                                &:first-child{
                                    width:50%;
                                }
                            }
                        }
                    }
                    tbody{
                        tr{
                            td{
                                text-align:center;
                                .product-col{
                                    display:flex;
                                    column-gap:16px;
                                    align-items:center;
                                    width:100%;
                                    padding:20px;
                                    .product-img{
                                        width: 96px;
                                        height:96px;
                                        border-radius:8px;
                                    }
                                    .product-info{
                                        display:flex;
                                        flex-direction:column;
                                        align-items:start;
                                        justify-content:flex-start;
                                        row-gap:12px;
                                        .product-name{
                                            color:#333;
                                            font-size:14px;
                                        }
                                        .product-spec{
                                            color:#666;
                                            font-size:14px;
                                        }
                                    }
                                }
                                p{
                                    color:#333;
                                    font-size:14px;
                                    &:last-child{
                                        text-decoration: line-through;
                                        color:#808080;
                                        font-size:12px;
                                    }
                                }
                            }
                        }
                    }
                }
                .product-info{
                    display:flex;
                    column-gap:16px;
                    .product-img{
                        width:96px;
                        height:96px;
                        border:1px solid #e3e3e3;
                        border-radius:8px;
                    }
                    .info-box{
                        display:flex;
                        justify-content:center;
                        flex-direction:column;
                        row-gap:33px;
                        .product-name{
                            color:#333;
                            font-size:14px;
                        }
                        .product-spec{
                            color:#666;
                            font-size:14px;
                        }
                    }
                }
                .price-box{
                    display:flex;
                    align-items:center;
                    color:#333;
                    font-size:14px;
                    margin-top:16px;
                    &.no-margin-top{
                        margin-top:0;
                    }
                    .price{
                        color:#ff5967;
                        font-size:20px;
                        font-weight:bold;
                    }
                }
                .price-list-box{
                    width:432px;
                    background:#f8f9fb;
                    border-radius:6px;
                    padding:10px;
                    display:flex;
                    flex-direction: column;
                    row-gap:6px;
                    margin-top:10px;
                    .list-item{
                        display:flex;
                        justify-content:space-between;
                        align-items:center;
                    }
                }
                .logistics-tips{
                    margin-top:8px;
                    color:#ff5000;
                    font-size:12px;
                    width:432px;
                }
                .time-order-no{
                    margin-top:16px;
                    color:#666;
                    font-size:14px;
                    display:flex;
                    row-gap:5px;
                    flex-direction:column;
                    margin-bottom:24px;
                    &.no-margin-bottom{
                        margin-bottom:0;
                    }
                }
                .reason-box{
                    display:flex;
                    flex-direction:column;
                    row-gap:8px;
                    margin-bottom:24px;
                    .reason-item{
                        display:flex;
                        align-items:center;
                        column-gap:5px;
                        color:#666;
                        font-size:14px;
                        .service-type{
                            color:#ff5967;
                            font-weight:bold;
                        }
                    }
                    .img-list{
                        display:flex;
                        column-gap:8px;
                        .img-item{
                            width:100px;
                            height:100px;
                            object-fit:cover;
                            &.video{
                                width:100px;
                                height:100px;
                            }
                        }
                        .video-wrapper{
                            position:relative;
                            width:100px;
                            height:100px;
                            cursor:pointer;
                            .video-overlay{
                                position:absolute;
                                top:0;
                                left:0;
                                width:100%;
                                height:100%;
                                background:transparent;
                                z-index:1;
                            }
                            .video-play-icon{
                                position:absolute;
                                top:50%;
                                left:50%;
                                transform:translate(-50%,-50%);
                                width:32px;
                                height:32px;
                                background:rgba(0,0,0,0.6);
                                border-radius:50%;
                                display:flex;
                                align-items:center;
                                justify-content:center;
                                z-index:2;
                                pointer-events:none;
                                svg{
                                    width:16px;
                                    height:16px;
                                    fill:#fff;
                                }
                            }
                            .video{
                                pointer-events:none;
                            }
                        }
                    }
                }
                .buyer-info{
                    display:flex;
                    flex-direction:column;
                    row-gap:9px;
                    padding-bottom:60px;
                    .buyer-info-item{
                        display:flex;
                        align-items:center;
                        column-gap:5px;
                        font-size:14px;
                        .buyer-info-value{
                            display:flex;
                            align-items:center;
                            column-gap:13px;
                        }
                        .contact-box{
                            display:flex;
                            align-items:center;
                            column-gap:13px;
                            cursor:pointer;
                            .icon{
                                width:22px;
                                height:22px;
                            }
                            .text{
                                color:#0d99ff;
                                font-size:14px;
                            }
                        }
                    }
                }
            }
            .right-body{
                flex:1;
                background:#f8f9fb;
                padding:24px;
                margin-bottom:60px;
                .right-part-title{
                    color:#333;
                    font-size:16px;
                    &.top-line{
                        border-top:1px solid #e3e3e3;
                        padding-top:40px;
                        margin-top:40px;
                    }
                }
                .return-info{
                    margin-top:16px;
                    color:#666;
                    font-size:14px;
                    display:flex;
                    flex-direction:column;
                    row-gap:8px;
                }
                .logistics-info-right{
                    width:100%;
                    min-height:120px;
                    max-height:360px;
                    padding:24px 24px 24px 38px;
                    border-radius:10px;
                    margin-top:16px;
                    background:#fff;
                    overflow-y:auto;
                    box-sizing:border-box;
                    .tracking-loading,
                    .empty-tracking{
                        text-align:center;
                        color:#999;
                        padding:60px 0;
                        font-size:14px;
                    }
                    &::-webkit-scrollbar-track {
                        background: transparent; /* 滚动条轨道背景 */
                        border-radius: 4px;
                    }
                    &::-webkit-scrollbar-button {
                        display: none !important; /* 隐藏滚动条的上下箭头按钮 */
                    }
                    .logistics-router-box{
                        width:100%;
                        display:flex;
                        flex-direction:column;
                        margin-top:10px;
                        position:relative;
                        padding-left:4px;
                        &::before{
                            content:'';
                            position:absolute;
                            left:169px;
                            top:7px;
                            bottom:14px;
                            width:2px;
                            background:#e0e0e0;
                        }
                        .logistics-router-item{
                            width:100%;
                            display:flex;
                            align-items:flex-start;
                            column-gap:20px;
                            position:relative;
                            .router-item-left{
                                width:140px;
                                flex-shrink:0;
                                color:#999;
                                font-size:12px;
                                line-height:1.6;
                                &.active{
                                    color:#333;
                                }
                            }
                            .router-item-center{
                                width:10px;
                                height:10px;
                                background:#d0d0d0;
                                border-radius:50%;
                                flex-shrink:0;
                                margin-top:5px;
                                position:relative;
                                z-index:2;
                                &.active{
                                    background:#ff5967;
                                    box-shadow:0 0 0 3px rgba(255,89,103,0.25);
                                }
                            }
                            .router-item-right{
                                flex:1;
                                min-width:0;
                                display:flex;
                                flex-direction:column;
                                row-gap:3px;
                                padding-bottom:22px;
                                .status{
                                    color:#ff5967;
                                    font-size:13px;
                                    font-weight:600;
                                    line-height:1.5;
                                }
                                .status-desc{
                                    color:#888;
                                    font-size:12px;
                                    line-height:1.6;
                                    word-break:break-all;
                                    &.active{
                                        color:#444;
                                    }
                                }
                            }

                            &:last-child{
                                .router-item-right{
                                    padding-bottom:0;
                                }
                            }
                        }
                    }
                }
                .remark-title{
                    color:#333;
                    font-size:14px;
                    margin-top:60px;
                }
                .remark{
                    margin-top:12px;
                    color:#666;
                    font-size:14px;
                }
            }
        }
    }
    .history-detail{
        width:100%;
        background:#fff;
        padding:23px 30px;
        margin-top:24px;
        .history-title{
            width:100%;
            color:#333;
            font-size:16px;
            border-bottom:1px solid #d6d6d6;
            padding-bottom:14px;
        }
        .history-list{
            display:flex;
            flex-direction:column;
            .history-list-item{
                width:100%;
                padding:16px 0;
                border-bottom:1px solid #d6d6d6;
                &:last-child{
                    border-bottom:none;
                }
                color:#666;
                font-size:13px;
                .history-list-item-title{
                    color:#333;
                    font-size:16px;
                    font-weight:500;
                }
            }
        }
    }
}
</style>
<style lang="scss">
// 视频预览弹窗样式 - 非scoped，因为弹窗是动态创建挂载到body的
.video-preview-mask{
    position:fixed;
    top:0;
    left:0;
    right:0;
    bottom:0;
    width:100vw;
    height:100vh;
    background:rgba(0,0,0,0.9);
    z-index:999999;
    display:flex;
    align-items:center;
    justify-content:center;
    .video-preview-container{
        position:relative;
        width:100%;
        height:100%;
        display:flex;
        align-items:center;
        justify-content:center;
        padding:20px;
        box-sizing:border-box;
        .video-preview-close{
            position:fixed;
            top:20px;
            right:20px;
            width:40px;
            height:40px;
            background:rgba(255,255,255,0.9);
            border-radius:50%;
            display:flex;
            align-items:center;
            justify-content:center;
            font-size:28px;
            color:#333;
            cursor:pointer;
            z-index:1000000;
            &:hover{
                background:#fff;
            }
        }
        .video-preview{
            max-width:90vw;
            max-height:90vh;
            width:auto;
            height:auto;
            object-fit:contain;
            border-radius:4px;
        }
    }
}

/* 视频检测 loading */
.video-preview-loading {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    padding: 60px 40px;
}
.video-loading-spinner {
    width: 40px;
    height: 40px;
    border: 4px solid rgba(255, 255, 255, 0.2);
    border-top-color: #0d99ff;
    border-radius: 50%;
    animation: video-spin 0.8s linear infinite;
}
@keyframes video-spin {
    to { transform: rotate(360deg); }
}
.video-detect-text {
    color: rgba(255, 255, 255, 0.7);
    font-size: 16px;
}

/* 视频不可播放提示 */
.video-unplayable-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 60px 40px;
    cursor: pointer;
    user-select: none;
    .hint-text {
        color: rgba(255, 255, 255, 0.7);
        font-size: 16px;
    }
    .download-link {
        color: #0d99ff;
        font-size: 16px;
        font-weight: 500;
    }
    &:hover .download-link {
        text-decoration: underline;
    }
}
.video-unplayable-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
<style lang="scss" scoped>
@media screen and (min-width: 1280px) and (max-width: 1679px) {
  .service-detail {
    // 整体缩放 90%
    transform: scale(0.9);
    transform-origin: top left; // 缩放原点设置为左上角
    width: calc(100% / 0.9); // 补偿缩放后的宽度
    height: calc(100% / 0.9); // 补偿缩放后的高度

  }
}
@media screen and (max-width: 1279px) {
  .service-detail {
    // 整体缩放 80%
    transform: scale(0.8);
    transform-origin: top left; // 缩放原点设置为左上角
    width: calc(100% / 0.8); // 补偿缩放后的宽度
    height: calc(100% / 0.8); // 补偿缩放后的高度

  }
}
</style>